import $ from "jquery";

const popularSearch = {
  variable:{
    url: window.location.href,
},

 methods : {

   buttonClickHandler : function (e) {
      $(".popularSearchDiv_ul_list_link").on('click', function(e){
         var obj = popularSearch.methods.dataLayerObj("Popular Search",e);
         createDataLayer('buttonClick', obj);
       });
     },

         dataLayerObj : function(el,e) {
                 var obj = {
                     'articleName' : "",
                     'blogCategory' : "",
                     'blogPageCategory' : "",
                     'buttonText' : e ? e.target.innerText.replace(/\n/g, '').trim() : "",
                     'pageSection' : el ? el : "",
                     'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? popularSearch.variable.url.includes("blog") ? "Blogs" : popularSearch.variable.url.substring(popularSearch.variable.url.indexOf(".com/"), popularSearch.variable.url.lastIndexOf('/')  === ".com") && !popularSearch.variable.url.substring(popularSearch.variable.url.indexOf(".com/"), popularSearch.variable.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                     'planOption' : "",
                     'productCategory' : "",
                     'productName' : "",
                     'question' : "",
                     'searchTerm' : "",
                     'videoTitle' : "",
                     'bannerName' : "",
                     'bannerType' : ""

                 };
                 return obj;
             }
    },
 };

$(document).ready(function () {
popularSearch.methods.buttonClickHandler();
});
